
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"17","height":"11","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-18 -432)","stroke":"#FFF","fill":"none","fill-rule":"evenodd"}},[_c('rect',{attrs:{"x":"18.5","y":"432.5","width":"16","height":"10","rx":"2"}}),_c('path',{attrs:{"d":"M19 433l7.538 4.666L34.076 433"}})])])
          )
        }
      }
    